import { lazy } from "react";
import { useTranslation } from "react-i18next";
import PropsTypes from "prop-types";

import { Modal, ModalFooter, ModalText } from "shared/components/Modals/Modal";

// import Lottie from "lottie-react";
import styles from "./SuccessUpdatePassword.module.scss";

import successAnimation from "assets/shared/lotties/success-mark.json";

const Lottie = lazy(() => import("lottie-react"));

export const SuccessUpdatePasswordModal = ({ show, close }) => {
  const { t } = useTranslation(["auth", "updatePassword"]);

  if (!show) {
    return null;
  }

  /*
   * Styles for animation wrap
   * */
  const style = {
    height: 120,
    width: 120,
    marginLeft: "auto",
    marginRight: "auto",
  };

  return (
    <Modal show={show} close={close}>
      <div className={styles.lottiWrap}>
        <Lottie
          loop={false}
          style={style}
          animationData={successAnimation}
          autoplay={true}
          rendererSettings={{
            preserveAspectRatio: "xMidYMid slice",
          }}
        />
      </div>
      <ModalText text={t("success", { ns: "updatePassword" })} isTitle={true} />
      <ModalText text={t("text", { ns: "updatePassword" })} />
      <ModalFooter>
        <button className={styles.primaryButton} onClick={close}>
          {t("okButton")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

SuccessUpdatePasswordModal.propTypes = {
  close: PropsTypes.func.isRequired,
  show: PropsTypes.bool.isRequired,
};
